import _ from 'lodash';

const getCouponById = (coupons = [], id) =>
  _.find(coupons, (c) => c.coupon_id === id);

export { getCouponById };
